package com.hyperether.goodjob.scenes.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.width
import androidx.compose.material.Divider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.util.toScaleDp

@Composable
fun DetailsDivider() {
    Divider(
        modifier = Modifier
            .width(1.toScaleDp())
            .fillMaxHeight()
            .background(BorderColor)
    )
}